import base64 from 'base-64';
export const InvalidUrlError = 'URL is not a valid signed URL';
/**
 * Valid CDN image output formats
 */
export const IMAGE_FORMATS = [
    'jpg',
    'jpeg',
    'png',
    'webp',
    'gif',
];
/**
 * Retrieve preferred CDN image output format for given (source) format
 *
 * This function attempts to preserve the source format if possible.
 */
export function getPreferredOutputFormat(format) {
    return IMAGE_FORMATS.includes(format)
        ? format
        : 'jpg';
}
export function isValidRemoteAssetHandlerUrl(signedUrl) {
    const url = new URL(signedUrl);
    return Boolean(url.searchParams.get('Policy') &&
        url.searchParams.get('Signature') &&
        url.searchParams.get('Key-Pair-Id'));
}
export function toRemoteAssetHandlerUrl(signedUrl, method, width, height, page, format, extraParameters) {
    if (!isValidRemoteAssetHandlerUrl(signedUrl)) {
        throw new Error(InvalidUrlError);
    }
    const url = new URL(signedUrl);
    const searchParams = url.searchParams;
    searchParams.set('width', width + '');
    searchParams.set('height', height + '');
    searchParams.set('method', method);
    if (page) {
        searchParams.set('page', page + '');
    }
    if (format && !['jpg', 'jpeg'].includes(format)) {
        searchParams.set('targetExtension', format);
    }
    url.pathname = url.pathname.replace('as3', 'api'); // replace is non-greedy and as3 is the first part of pathname
    if (extraParameters) {
        extraParameters.forEach(extra => {
            searchParams.append(extra.key, extra.value || 'true');
        });
    }
    return url.toString();
}
export function getSignedUrlForThumb(file, supportedExtensions = [...IMAGE_FORMATS, 'pdf'], image = 'default') {
    if (file.signedImageUrls && file.signedImageUrls[image]) {
        return file.signedImageUrls[image];
    }
    else if (file.signedUrl && supportedExtensions.includes(file.extension)) {
        return file.signedUrl;
    }
    return null;
}
export function isSignedUrl(signedUrl) {
    return getExpirationDate(signedUrl) !== undefined;
}
/**
 * Retrieve expiration date for a signed URL
 *
 * Throws error if URL is not a valid signed URL.
 */
export function getExpirationDate(signedUrl) {
    try {
        const url = new URL(signedUrl);
        const policyParam = url.searchParams.get('Policy');
        if (policyParam) {
            const policy = decodePolicy(policyParam);
            const dateCondition = policy.Statement[0].Condition?.DateLessThan;
            if (!dateCondition) {
                return undefined;
            }
            const expiration = dateCondition['AWS:EpochTime'];
            return expiration ? new Date(expiration * 1000) : undefined;
        }
    }
    catch (e) {
        //
    }
    return undefined;
}
/**
 * Test if given signed URL is expired
 *
 * Throws error if URL is not a valid signed URL.
 */
export function isExpired(signedUrl) {
    return !isValidUntil(signedUrl, new Date());
}
/**
 * Test if signed URL is valid until given date
 *
 * If the date given is equal to date of expiration, this
 * method returns false.
 */
export function isValidUntil(signedUrl, date) {
    const expirationDate = getExpirationDate(signedUrl);
    if (!expirationDate) {
        return false;
    }
    return expirationDate > date;
}
export function encodePolicy(policy) {
    let encodedPolicy = base64.encode(JSON.stringify(policy));
    return encodedPolicy
        .replace(/\+/g, '-')
        .replace(/=/g, '_')
        .replace(/\//g, '~');
}
function decodePolicy(policy) {
    const decoded = base64.decode(policy.replace(/-/g, '+').replace(/_/g, '=').replace(/~/g, '/'));
    return JSON.parse(decoded);
}
